import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminManageStandardFeesPage = React.lazy(() => import(/* webpackChunkName: "AdminManageStandardFees" */ './Page'));
export const AdminManageStandardFees = () => (React.createElement(Page, { title: "Administrator Manage Standard Fees" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminManageStandardFeesPage, null)))));
